import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';
import { PROPERTY_PROGRESS_SLICE_NAME, PropertyProgressState } from './models';

export const propertyProgressSelector = (state: RootState): PropertyProgressState =>
  state[PROPERTY_PROGRESS_SLICE_NAME];

export const selectPropertyProgressIsLoading = createSelector(
  propertyProgressSelector,
  (state: PropertyProgressState) => state.isLoading,
);

export const selectPropertyOwner = createSelector(
  propertyProgressSelector,
  (state: PropertyProgressState) => state.propertyOwner,
);

export const selectTotalOrdersSum = createSelector(
  propertyProgressSelector,
  (state: PropertyProgressState) => state.totalOrdersSum,
);

export const selectStepsProgresses = createSelector(
  propertyProgressSelector,
  (state: PropertyProgressState) => state.stepsProgresses,
);

export const selectProgress = createSelector(
  propertyProgressSelector,
  (state: PropertyProgressState) => state.progress,
);
